import { render } from "./withAdminLayout.vue?vue&type=template&id=e9dbb404"
import script from "./withAdminLayout.vue?vue&type=script&lang=js"
export * from "./withAdminLayout.vue?vue&type=script&lang=js"

import "./withAdminLayout.vue?vue&type=style&index=0&id=e9dbb404&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__